/*
 *###############################################################################
 *Module Name                   : PromotionMaster.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Dinisuru Balasuriya                           #
 *Date                          : Monday , March 7th 2022, 10:10:07 am          #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */


import React, { useState } from "react"
import {
    Col,
    Row
} from "reactstrap"

//**Importing required componant files   */
import DPSwitch from "framework/components/DPSwitch"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import BinDownload from "../../../assets/File/Bin.xlsx";
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import { DecimalValidation, Numeric } from "../../../framework/validators/TextValidation"
import * as XLSX from "xlsx";
//**End Importing required componant files */


const PromotionPaymentModeContent = ({
    allpaymodes,
    setAllpaymodes,
    disabled,
    showAllFields,
    payAct,
    setBinList,
    binList,
    setBin
}) => {

    const [bincode, setBincode] = useState("");
    const [ExcelItems, setExcelItems] = useState([]);


    function addbin() {
        if (bincode != "") {
            setBinList([...binList, bincode]);
            setBincode("");
        }
    }

    function removebin(index) {
        binList.splice(index, 1);
        setBinList([...binList]);
    }

    function handleStoleNameChange(e, values, index) {
        var newStoles = []
        var newvalue = Numeric(e.target, 15, 0, false)
        for (var i = 0; i < binList.length; i++) {
            if (i == index) {
                newStoles.push(newvalue);
            } else {
                newStoles.push(binList[i]);
            }
        }
        setBinList(newStoles);
    }

    const readExcel = (file) => {

        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
            const bufferArray = e.target.result;
            const wb = XLSX.read(bufferArray, { type: "buffer" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);
            var newList = []
            data.map((item, index) => {
                newList.push(item.Bin)
            })
            setExcelItems(data);

            setBinList(newList);

        };
    };


    function HandlePaymentRowChange(element, values, index) {
        let paymentDet = [...allpaymodes];
        paymentDet[index][element] = values;
        setAllpaymodes(paymentDet);
    }


    return (
        <React.Fragment>

            {showAllFields && payAct ? <Row>
                <Col sm={12} md={12} className="mb-12-sm">

                    <table id={"paymodetypes"}>
                        <thead className="table-light">
                            <tr>
                                <th>Detail Code</th>
                                <th>Detail Description</th>
                                <th>Header Description</th>
                                <th style={{ textAlign: "right" }}>Minimum Value</th>
                                <th style={{ textAlign: "right" }}>Maximum Value</th>
                                <th style={{ textAlign: "right" }}>Discount %</th>
                                <th style={{ textAlign: 'center' }}>Apply</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(allpaymodes || []).map((item, index) => (
                                <TableRow FormRow={item} Key={index} Disable={disabled} HandlePaymentRowChange={HandlePaymentRowChange} />
                            ))}

                        </tbody>
                    </table>

                </Col>
            </Row> : null}

            {setBin ? <Row className="mt-5 mb-2">
                <Col sm={12} md={4} className="mb-12-sm">
                    <DPTextBoxforgrid
                        placeholder={"Bin Code"}
                        name="Gen_strDetailCode"
                        value={bincode}
                        onChange={(e) => {
                            var newvalue = Numeric(e.target, 15, 0, false)
                            setBincode(newvalue)
                        }}
                        disabled={disabled}
                    />
                </Col>
                <Col sm={12} md={1} className="mb-12-sm">
                    <button type="button" className="btn btn-primary btn-sm" disabled={disabled} onClick={() => {
                        addbin()
                    }}>
                        <i className="fa fa-plus"></i>
                    </button>

                </Col>
                <Col sm={12} md={2} className="mb-4-sm">
                    <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px" }}>
                        <li className="import-export-button" style={{ display: "block" }}>
                            <input
                                id="file"
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    readExcel(file);
                                }}
                                //  value={valueUpload}
                                disabled={disabled}
                                accept=".xlsx, .xls, .csv"
                                style={{ display: "none" }}
                            />

                            <label htmlFor="file" title="Bin Excel Upload" style={{ cursor: "pointer", opacity: disabled == true ? "0.5" : "1" }}>
                                <span >
                                    <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                                </span>
                            </label></li>

                        <li className="import-export-button" style={{ display: "block" }}>
                            <a href={BinDownload} download="Bin Upload" data-tip title="Bin excel format download"
                                style={{ pointerEvents: disabled ? 'none' : '', }} >
                                <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabled == true ? "0.5" : "1" }}></img>
                            </a></li>
                    </ul>
                </Col>
            </Row> : null}

            {setBin && binList.map((item, index) => {
                return (
                    <Row className="mt-1">
                        <Col sm={12} md={4} className="mb-12-sm">
                            <DPTextBoxforgrid
                                placeholder={"Bin Code"}
                                name="Gen_strDetailCode"
                                value={item}
                                onChange={(e) => { handleStoleNameChange(e, item, index) }}
                                disabled={disabled}
                            />
                        </Col>
                        <Col sm={12} md={1} className="mb-12-sm">
                            <button type="button" className="btn btn-danger btn-sm" disabled={disabled} onClick={() => {
                                removebin(index)
                            }}>
                                <i className="fa fa-trash"></i>
                            </button>
                        </Col>
                    </Row>
                )
            }
            )}

        </React.Fragment>
    )
}

const TableRow = ({ FormRow, Disable, Key, HandlePaymentRowChange }) => {

    return (
        <tr key={Key}>
            <td style={{ width: "160px" }}>

                <DPTextBoxforgrid
                    id={"pdcode" + Key}
                    rowClass="mb-12-sm"
                    value={FormRow.pD_CODE}
                    disabled={true}
                />
            </td>
            <td style={{ width: "200px" }}>

                <DPTextBoxforgrid
                    id={"pddesc" + Key}
                    rowClass="mb-12-sm"
                    value={FormRow.pD_DESC}
                    disabled={true}
                />
            </td>
            <td style={{ width: "160px", display: 'none' }}>
                <DPTextBoxforgrid
                    id={'pdphcode' + Key}
                    rowClass="mb-12-sm"
                    value={FormRow.pD_PHCODE}
                    disabled={true}
                />
            </td>
            <td style={{ width: "160px" }}>
                <DPTextBoxforgrid
                    id={'pdphdesc' + Key}
                    rowClass="mb-12-sm"
                    value={FormRow.pH_DESC}
                    disabled={true}
                />
            </td>

            <td style={{ width: "160px" }}>

                <DPTextBoxforgrid
                    id={"pdmin" + Key}
                    rowClass="mb-12-sm"
                    value={FormRow.pD_PHMin}
                    onChange={(e) => {
                        let val = Numeric(e.target, 8, 2, false)
                        HandlePaymentRowChange('pD_PHMin', val, Key)
                    }}
                    onBlur={(e) => {
                        let val = DecimalValidation(e.target.value, 0, true, 2)
                        if (val != '') {
                            HandlePaymentRowChange('pD_PHMin', parseFloat(val).toFixed(2), Key)
                        } else {
                            HandlePaymentRowChange('pD_PHMin', parseFloat(0).toFixed(2), Key)
                        }
                    }}
                    disabled={Disable}
                    textAlign={"right"}
                />
            </td>
            <td style={{ width: "160px" }}>

                <DPTextBoxforgrid
                    id={"pdmax" + Key}
                    rowClass="mb-12-sm"
                    value={FormRow.pD_PHMax}
                    onChange={(e) => {
                        let val = Numeric(e.target, 8, 2, false)
                        HandlePaymentRowChange('pD_PHMax', val, Key)
                    }}
                    onBlur={(e) => {
                        let val = DecimalValidation(e.target.value, 0, true, 2)
                        if (val != '') {
                            HandlePaymentRowChange('pD_PHMax', parseFloat(val).toFixed(2), Key)
                        } else {
                            HandlePaymentRowChange('pD_PHMax', parseFloat(0).toFixed(2), Key)
                        }
                    }}
                    disabled={Disable}
                    textAlign={"right"}

                />
            </td>
            <td style={{ width: "160px" }}>

                <DPTextBoxforgrid
                    id={"pdDiscount" + Key}
                    rowClass="mb-12-sm"
                    value={FormRow.pD_PHDiscount}
                    onChange={(e) => {
                        let val = Numeric(e.target, 8, 2, true)
                        HandlePaymentRowChange('pD_PHDiscount', val, Key)
                    }
                    }
                    onBlur={(e) => {
                        let val = DecimalValidation(e.target.value, 0, true, 2)
                        if (val != '') {
                            if (val > 100) {
                                HandlePaymentRowChange('pD_PHDiscount', parseFloat(0).toFixed(2), Key)
                            } else if (val == -1) {
                                HandlePaymentRowChange('pD_PHDiscount', parseFloat(val).toFixed(2), Key)
                            } else if (val < -1) {
                                HandlePaymentRowChange('pD_PHDiscount', parseFloat(0).toFixed(2), Key)
                            } else if (val < 0) {
                                HandlePaymentRowChange('pD_PHDiscount', parseFloat(val).toFixed(2), Key)
                            } else {
                                HandlePaymentRowChange('pD_PHDiscount', parseFloat(val).toFixed(2), Key)
                            }
                        } else {
                            HandlePaymentRowChange('pD_PHDiscount', parseFloat(0).toFixed(2), Key)
                        }
                    }}
                    disabled={Disable}
                    textAlign={"right"}
                />
            </td>

            <td style={{ width: "160px", textAlign: 'center' }}>
                <DPSwitch
                    id={'apply' + Key}
                    rowClass="mb-12-sm"
                    checked={FormRow.apply}
                    onChange={(e) => {
                        HandlePaymentRowChange('apply', e, Key)
                    }}
                    disabled={Disable}

                />

            </td>
        </tr>
    )


}



export default PromotionPaymentModeContent
